export default __webpack_public_path__ + "static/media/Crow Shadow Tasset.4ce0a5c9.jpg";